import './style.css';
import Feature from 'ol/Feature.js';
import Map from 'ol/Map.js';
import Overlay from 'ol/Overlay.js';
import Point from 'ol/geom/Point.js';
import VectorSource from 'ol/source/Vector.js';
import View from 'ol/View.js';
import { Icon, Style } from 'ol/style.js';
import { Tile as TileLayer, Vector as VectorLayer } from 'ol/layer.js';
import { fromLonLat } from 'ol/proj';
import {defaults} from 'ol/interaction.js';
import OSM from 'ol/source/OSM.js';

const createCustomMarkerLayer = function (lat, lon, header = '', body = '') {
  const iconFeature = new Feature({
    geometry: new Point(fromLonLat([lon, lat])),
    name: '<strong>' + header + '</strong>' + body,
    population: 4000,
    rainfall: 500,
  });

  const iconStyle = new Style({
    image: new Icon({
      anchor: [0.5, 46],
      anchorXUnits: 'fraction',
      anchorYUnits: 'pixels',
      src: 'data/map-pin.png',
    }),
  });

  iconFeature.setStyle(iconStyle);

  const vectorSource = new VectorSource({
    features: [iconFeature],
  });

  const vectorLayer = new VectorLayer({
    source: vectorSource,
  });

  return vectorLayer;
}


fetch('data/locations.json')
  .then(response => {
    response.json()
      .then(locations => {
        const map_layers = [new TileLayer({ source: new OSM() })];
        locations.map(l => {
          map_layers.push(createCustomMarkerLayer(l.lat, l.lon, l.title, l.content))
        });
        const map = new Map({
          layers: map_layers,
          target: document.getElementById('map'),
          interactions: defaults({ mouseWheelZoom: false }),
          view: new View({
            center: fromLonLat([10.3744672, 49.9532139]),
            zoom: 5,
          }),
        });

        const element = document.getElementById('popup');

        const popup = new Overlay({
          element: element,
          positioning: 'bottom-center',
          stopEvent: false,
        });
        map.addOverlay(popup);

        let popover;
        function disposePopover() {
          if (popover) {
            popover.dispose();
            popover = undefined;
          }
        }
        // display popup on click
        map.on('click', function (evt) {
          const feature = map.forEachFeatureAtPixel(evt.pixel, function (feature) {
            return feature;
          });
          disposePopover();
          if (!feature) {
            return;
          }
          popup.setPosition(evt.coordinate);
          popover = new bootstrap.Popover(element, {
            placement: 'top',
            html: true,
            content: feature.get('name'),
          });
          popover.show();
        });

        // change mouse cursor when over marker
        map.on('pointermove', function (e) {
          const pixel = map.getEventPixel(e.originalEvent);
          const hit = map.hasFeatureAtPixel(pixel);
          map.getTarget().style.cursor = hit ? 'pointer' : '';
        });
        // Close the popup when the map is moved
        map.on('movestart', disposePopover);
      })
  });


